(function ($, Drupal) {
  Drupal.behaviors.pageNavigation = {
    attach: function (context) {
      once('pageNavigation', 'html', context).forEach(function (html) {
        const navigation = html.querySelector('#navigation');
        const open = html.querySelector('#navigation-open');
        const close = html.querySelector('#navigation-close');

        open.addEventListener('click', function () {
          const modalTriggers = html.querySelectorAll('[data-modal]');

          modalTriggers.forEach(function (modalTrigger) {
            const modal = html.querySelector(modalTrigger.dataset.modal);
            modalTrigger.dataset.expandedContact = 'false';
            modal.dataset.expandedContact = 'false';
          });

          navigation.classList.remove('is-expanded-contact');
          navigation.classList.add('is-expanded');
        });

        close.addEventListener('click', function () {
          navigation.classList.remove('is-expanded');
        });
      });
    },
  };
}(jQuery, Drupal));
